import { useState, useEffect } from "react"
import { httpLogin } from "Utils/httpLogin";
import { STATUSES } from "Utils/constants";

// custom hook to wrap BroadcastChannel api
const useBoradcast = (channelName) => {

  const [message, setMessage] = useState(null);
  const channel = new BroadcastChannel(channelName);

  useEffect(() => {
    const handleMessage = (event) => {
      setMessage(event.data);

      //log out when detect log out from other tab
      if (event.data?.status == STATUSES.LOG_OUT.text) {
        channel.close();
      }
    };

    channel.onmessage = handleMessage;
  }, [channel]);

  const sendMessage = (msg) => {
    channel.postMessage(msg);
  };

  return { message, sendMessage };
};

export default useBoradcast;